import { IndexPage, BasketPage, BuildSelectorPage } from './IndexPage';
import { SummaryPage } from './SummaryPage';

export {
    IndexPage,
    BasketPage,
    BuildSelectorPage,
    SummaryPage
    }


/** WEBPACK FOOTER **
 ** ./Typescript/Pages/GameBuildConfiguration/index.ts
 **/